import React, { ReactNode } from 'react';
import PageFailedLoading from './PageFailedLoading';
import { Spinner } from '@/Components/shadcn';

interface PageContentLoadingProps {
    isLoading: boolean;
    loadingFailed: boolean;
    children: ReactNode;
}

const PageContentLoading = ({ isLoading, loadingFailed, children }: PageContentLoadingProps) => {
    if (isLoading) {
        return <Spinner className="text-primary mx-auto flex size-10 h-full" />;
    }

    if (loadingFailed) {
        return <PageFailedLoading />;
    }

    return children;
};

export default PageContentLoading;
